import { useEffect, useState } from 'react';

import {
  setReplaceSingleItemWithoutSuggestions,
  sfWithoutSuggestionsModalObserver,
} from 'features/order/substitution-flow/infra';
import { invalidateGetOrderDetailById } from 'shared/hooks';
import { useSFWithoutSuggestionsModalLang } from './useSFWithoutSuggestionsModalLang';

import { SELECTED_ITEMS_OUT_STOCK_INIT as ITEMS_INIT } from 'features/order/substitution-flow/domain';
import { ORDER_DETAIL_MODEL_INIT as ORDER_INIT } from 'shared/domain';

export function useSFWithoutSuggestionsModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [fromChatBtn, setFromChatBtn] = useState(false);
  const [order, setOrder] = useState(ORDER_INIT);
  const [itemsOutStock, setItemsOutStock] = useState(ITEMS_INIT);

  const withoutSuggestionsModal = sfWithoutSuggestionsModalObserver();

  const lang = useSFWithoutSuggestionsModalLang();

  const handleClose = () => {
    setOrder(ORDER_INIT);
    setItemsOutStock(ITEMS_INIT);
    invalidateGetOrderDetailById(order.id);
    setIsOpen(false);
  };

  const handleSend = () => {
    setReplaceSingleItemWithoutSuggestions({
      order,
      itemsOutStock,
      fromChatBtn,
    })
      .then(_ => handleClose())
      .catch(error => alert(error.message ?? 'The action has failed'));
  };

  useEffect(() => {
    withoutSuggestionsModal.add(({ detail }) => {
      setOrder(detail.order);
      setItemsOutStock(detail.itemsOutStock);
      setFromChatBtn(detail.fromChatBtn);
      setIsOpen(true);
    });
    return () => {
      withoutSuggestionsModal.remove();
    };
  }, []);

  return {
    lang,
    isOpen,
    orderId: order.id,
    handleClose,
    handleSend,
  };
}
